// Leaves for the sign-in screen with a fresh page, so nothing the previous session held in memory
// (stores, components, timers) carries over to whoever signs in next.
export function navigateToSignIn() {
  window.location.replace('/auth')
}
